import { WarningCircle } from "@phosphor-icons/react";

const WifiInput = ({ wifi_name, wifi_password, onChange, errors }) => {
    return (
        <div className="input-group border-b-[1.5px] py-3 h-[180px]">
            <label className="block text-sm">Wifi Name</label>
            <input
                type="text"
                value={wifi_name}
                onChange={(e) => onChange("wifi_name", e.target.value)}
                placeholder="Enter the hotel wifi network name"
                className="mt-1 block w-[95%] p-2 border-[1.5px] border-gray-300 rounded-lg"
            />
            {errors.wifi_name && (
                <span className="text-[#E47186] text-xs flex items-center gap-1">
                    <WarningCircle className="text-sm" />
                    {errors.wifi_name}
                </span>
            )}
            <label className="block text-sm mt-4">Wifi Password</label>
            <input
                type="text"
                value={wifi_password}
                onChange={(e) => onChange("wifi_password", e.target.value)}
                placeholder="Enter the hotel wifi password"
                className="mt-1 block w-[95%] p-2 border-[1.5px] border-gray-300 rounded-lg"
            />
            {errors.wifi_password && (
                <span className="text-[#E47186] text-xs flex items-center gap-1">
                    <WarningCircle className="text-sm" />
                    {errors.wifi_password}
                </span>
            )}
        </div>
    );
};

export default WifiInput;
